module.exports = __webpack_public_path__ + "img/weather_2.4c6f4bdb.jpg";